import { defineStore } from "pinia";
import services from "@/services";
import useApi from "@/hooks/useApi";
import useInfo from './info';

interface ComicState {
  comics: string[];
  showComicReader: boolean;
}

const useComic = defineStore('comic', {
  state: (): ComicState => ({
    comics: [],
    showComicReader: false,
  }),
  actions: {
    async getComic() {
      const { lang, region } = useInfo();
      if (!lang || !region) return;
      const response = await useApi(() => services.getComic(
        {
          region,
          lang,
          ...(this.storageToken && { accessToken: this.storageToken })
        }));
      if (!response || response.msg) return;
      const { data } = response;
      this.$patch({
        ...data,
        showComicReader: true,
      });
    },
    updateShowComicReader(showComicReader: boolean) {
      this.showComicReader= showComicReader;
    },
  },
  getters: {
    storageToken() {
      return localStorage.getItem('TOKEN');
    }
  },
});

export default useComic;
